export function normalizeAssignedStoreOption(store) {
  if (!store) return null;

  const merchantId = store.merchant_id || store.id || store.value;
  const name = store.name || store.label;

  if (!merchantId || !name) return null;

  return {
    value: merchantId,
    merchant_id: merchantId,
    name,
    label: name,
    id: merchantId,
    raw: store,
  };
}

export function getEmployeeAssignedStoreList(employee, storeOptions = []) {
  if (Array.isArray(employee?.assigned_stores) && employee.assigned_stores.length > 0) {
    return employee.assigned_stores
      .map(normalizeAssignedStoreOption)
      .filter(Boolean);
  }

  if (!employee?.assigned_store) return [];

  const merchantIdSet = new Set(
    employee.assigned_store
      .split(",")
      .map((id) => id.trim().toUpperCase())
      .filter(Boolean),
  );

  return (storeOptions || []).filter((option) =>
    merchantIdSet.has((option?.merchant_id || "").toUpperCase()),
  );
}

export function getEmployeeAssignedStoreCount(employee) {
  if (Array.isArray(employee?.assigned_stores) && employee.assigned_stores.length > 0) {
    return employee.assigned_stores.length;
  }

  return (employee?.assigned_store || "").split(",").filter(Boolean).length;
}

export function getEmployeeAssignedStoreIds(employee) {
  if (Array.isArray(employee?.assigned_stores) && employee.assigned_stores.length > 0) {
    return employee.assigned_stores
      .map((store) => store.merchant_id)
      .filter(Boolean)
      .sort();
  }

  return (employee?.assigned_store || "").split(",").filter(Boolean).sort();
}

/** Build merchant_id -> store name map from any mix of option/detail objects. */
export function buildStoreNameMap(...storeLists) {
  const map = new Map();

  storeLists.forEach((list) => {
    if (!Array.isArray(list)) return;

    list.forEach((store) => {
      if (!store) return;

      const merchantId = store.merchant_id || store.id || store.value;
      const name = store.name || store.label;
      if (!merchantId || !name) return;

      const id = String(merchantId);
      map.set(id, name);
      map.set(id.toUpperCase(), name);
    });
  });

  return map;
}

export function getStoreDisplayName(storeNameMap, merchantId) {
  if (!merchantId) return "";

  const id = String(merchantId);
  return (
    storeNameMap?.get(id) ||
    storeNameMap?.get(id.toUpperCase()) ||
    id
  );
}
